// extracted by mini-css-extract-plugin
export default {"wrapper":"y6AboGk","container":"nZRhTDR","title":"-YwDV+f","subtitle":"WK2lJ8r","button":"_1LpqQ2Y","input":"MmXR-SP","inner-input":"_9Dm39DZ","innerInput":"_9Dm39DZ"};